module.exports = __webpack_public_path__ + "img/placeholder-banner.ce3d3a87.svg";